import { useMemo } from 'react';

import algoliasearch from 'algoliasearch';
import type { SearchClient } from 'algoliasearch/lite';

export function useSearchClient(appId: string, apiKey: string): SearchClient {
  const searchClient = useMemo(() => {
    const client = algoliasearch(appId, apiKey);

    return client;
  }, [appId, apiKey]);

  return searchClient;
}
